<div class="settings-header">
    <div class="header-left">
        <button *ngIf="showBackButton" class="back-button" mat-button (click)="onBack()">
            <mat-icon>chevron_left</mat-icon>
        </button>
        <h2 class="header-title">{{ title | translate }}</h2>
    </div>
    <div class="header-actions">
        <button *ngIf="showSyncButton" mat-stroked-button class="sync-button" (click)="onSync()">
            {{ syncButtonTranslationKey | translate }}
        </button>
        <button *ngIf="showCreateButton" mat-flat-button color="primary" class="create-button" (click)="onCreate()">
            {{ createButtonTranslationKey | translate }}
        </button>
    </div>
</div>
